  <span *ngIf="hasPasswordStored" class="p-input-icon-right max-width">
    <svg-icon class="eye-icon" role="button" aria-label="Toggle Password Visibility" (click)="toggleFieldType()" key="eye"></svg-icon>
    <aero-input [type]="type"
                [id]="'passwordId'"
                [name]="'password'"
                [required]="true"
                [errorMessage]="errorMessage"
                [errors]="error"
                [(ngModel)]="usernameOrPassword"
                (change)="onValueChange($event)"
                label="{{ 'account_settings_new_password' | translate }}">
    </aero-input>
  </span>
  <aero-input *ngIf="!hasPasswordStored" type="text"
              [id]="'passwordIdn'"
              [name]="'password'"
              [required]="true"
              [errorMessage]="errorMessage"
              [errors]="error"
              [(ngModel)]="usernameOrPassword"
              (change)="onValueChange($event)"
              label="{{ 'sign_in_password' | translate }}">
  </aero-input>
